// extracted by mini-css-extract-plugin
module.exports =  {"centreThumbnail":"styles-module_centreThumbnail__mJRLLs1CS736mI4eKhsS"};